import React, { useEffect, useState } from 'react'
import { collection, onSnapshot, orderBy, query, where, limit } from 'firebase/firestore'
import { db } from '../../../firebase/firebaseapi'
import OrderTable from './orderTable';
import Loader from '@common/src/common/loader/loader';
import PropTypes from 'prop-types';
import { ALL_OPTION } from '@pulse/constants/constants';
import { useSelector } from 'react-redux';
import { DISPUTE_ORDERS_STATUS_LIST } from './common';

const LiveOrders = ({ store }) => {
    const [orders, setOrders] = useState([])
    const [loading, setLoading] = useState(true)
    const [selectedFilterStatusValue, setSelectedFilterStatusValue] = useState(ALL_OPTION.status);
    const { stores = [] } = useSelector((state) => state.auth || {});


    useEffect(() => {
        // fetch orders on mount
        const unsubscribe = fetchLiveOrders()
        return () => {
            if (unsubscribe) unsubscribe()
        }
    }, [store, selectedFilterStatusValue])

    const fetchLiveOrders = () => {
        setLoading(true);
        // Constructing the query dynamically
        const ordersRef = collection(db, "orders");
        let qlimit = 100;
        const unsubscribes = [];
        let allOrders = [];

        const buildQuery = (companyIdsBatch) => {
            const filters = [];

            // Only add status filter if not 'all' to avoid multiplying disjunctions
            if (selectedFilterStatusValue?.value !== 'all') {
                filters.push(where("orderStatus", "==", selectedFilterStatusValue?.value));
            }

            if (companyIdsBatch) {
                filters.push(where("companyId", "in", companyIdsBatch));
            }

            return query(ordersRef, ...filters, orderBy("orderDate", "desc"), limit(qlimit));
        };

        if (store?.value === ALL_OPTION.stores.value) {
            const companyIds = Array.from(new Set(stores.map(store => {
                const companyId = Number.parseInt(store.companyId);
                return Number.isNaN(companyId) ? null : companyId;
            }))).filter(id => id !== null);

            // Split into chunks of 10 to avoid exceeding 30 disjunctions limit
            const chunkSize = 10;
            const chunks = [];
            for (let i = 0; i < companyIds.length; i += chunkSize) {
                chunks.push(companyIds.slice(i, i + chunkSize));
            }

            // If no companyIds, still execute one query
            if (chunks.length === 0) {
                const q = buildQuery(null);
                const unsubscribe = onSnapshot(q, (querySnapshot) => {
                    const ordersList = [];
                    querySnapshot.forEach((doc) => {
                        ordersList.push({ ...doc.data(), id: doc.id });
                    });
                    allOrders = ordersList;
                    setOrders(prioritizeAndLimitOrders(allOrders));
                    setLoading(false);
                });
                unsubscribes.push(unsubscribe);
            } else {
                // Execute queries for each chunk
                chunks.forEach((chunk) => {
                    const q = buildQuery(chunk);
                    const unsubscribe = onSnapshot(q, (querySnapshot) => {
                        // Remove old orders from this chunk and add new ones
                        querySnapshot.forEach((doc) => {
                            const orderData = { ...doc.data(), id: doc.id };
                            const existingIndex = allOrders.findIndex(o => o.id === doc.id);
                            if (existingIndex >= 0) {
                                allOrders[existingIndex] = orderData;
                            } else {
                                allOrders.push(orderData);
                            }
                        });
                        setOrders(prioritizeAndLimitOrders(allOrders));
                        setLoading(false);
                    });
                    unsubscribes.push(unsubscribe);
                });
            }
        } else {
            const filters = [];
            if (selectedFilterStatusValue?.value !== 'all') {
                filters.push(where("orderStatus", "==", selectedFilterStatusValue?.value));
            }
            filters.push(where("storeId", "==", Number.parseInt(store?.value)));

            const liveOrdersQuery = query(ordersRef, ...filters, orderBy("orderDate", "desc"), limit(qlimit));
            const unsubscribe = onSnapshot(liveOrdersQuery, (querySnapshot) => {
                let ordersList = [];
                querySnapshot.forEach((doc) => {
                    ordersList.push({ ...doc.data(), id: doc.id });
                });
                setOrders(ordersList);
                setLoading(false);
            });
            unsubscribes.push(unsubscribe);
        }

        // Return a function that unsubscribes from all listeners
        return () => {
            unsubscribes.forEach(unsubscribe => unsubscribe && unsubscribe());
        };
    };

    const prioritizeAndLimitOrders = (ordersList) => {
        // First exclude failed orders
        let filtered = ordersList.filter(order => !DISPUTE_ORDERS_STATUS_LIST.includes(order.orderStatus));

        // Then filter by status client-side if 'all' is selected
        if (selectedFilterStatusValue?.value !== 'all') {
            filtered = filtered.filter(order => order.orderStatus === selectedFilterStatusValue?.value);
        }
        // Sort by orderDate descending and limit to 100
        return filtered
            .sort((a, b) => (b.orderDate?.seconds || 0) - (a.orderDate?.seconds || 0))
            .slice(0, 100);
    };
    useEffect(() => {
        // Clear filters on store change
        setSelectedFilterStatusValue(ALL_OPTION.status);
    }, [store])

    const onAllFilter = (selectedStartDate, selectedEndDate, selectedStatus) => {

        // Clear all filters
        setSelectedFilterStatusValue(ALL_OPTION.status);
        if (selectedStatus?.value) {
            setSelectedFilterStatusValue(selectedStatus)
        }

    }
    if (loading) return <Loader />
    return (
        <div className="mt-6 table-responsive">
            <OrderTable
                orders={orders}
                timeStamp={true}
                onFilter={onAllFilter}
                selectedFilterStatus={[selectedFilterStatusValue]}
                type='live'
                loading={loading}

            />
        </div>
    )
};

LiveOrders.propTypes = {
    store: PropTypes.object,
}
export default LiveOrders;
